module.exports = __webpack_public_path__ + "static/[edgeinnovationcenter.com][411]4-2-4d650f4d924c2c8f31bbab4310532639.jpg";